export function shouldParseCodeViewErrorResponse(response: {status: number}): boolean {
  return response.status === 404
}
